<div class="container-fluid" style="height: inherit">
    <div class="row" style="height: inherit">
        <div class="menu col-md-1" *ngIf="tab.isMenuVisible">
            <ng-container *ngIf="hasMultiTemplates()">
                <div style="margin: auto; margin-top: 0; margin-bottom: 0; position: relative">
                    <a
                        *ngIf="userService.userHasRight('Création', tab.droitTitle)"
                        class="btn btn-outline-warning"
                        #tooltip="matTooltip"
                        [matTooltip]="tooltipTranslate.create | translate"
                        (click)="onOpenAddElement($event)"
                        matTooltipPosition="left"
                    >
                        <mat-icon>add</mat-icon>
                    </a>
                    <div
                        #addElementRef
                        class="addElement"
                        [ngClass]="{ 'd-none': !isOpenAddElement }"
                    >
                        <div class="form-check" *ngFor="let template of templates">
                            <button
                                mat-menu-item
                                class="cree btn-outline-warning"
                                (click)="ajouterUnEntite(tab.entite, template)"
                            >
                                {{ template.titre }}
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!hasMultiTemplates()">
                <a
                    *ngIf="userService.userHasRight('Création', tab.droitTitle)"
                    class="btn btn-outline-warning"
                    #tooltip="matTooltip"
                    [matTooltip]="tooltipTranslate.create | translate"
                    matTooltipPosition="left"
                    (click)="ajouterUnEntite(tab.entite, null)"
                >
                    <mat-icon>add</mat-icon>
                </a>
            </ng-container>

            <a
                class="btn btn-outline-warning"
                #tooltip="matTooltip"
                [matTooltip]="tooltipTranslate.refresh | translate"
                matTooltipPosition="left"
                (click)="rafraichir()"
            >
                <mat-icon>refresh</mat-icon>
            </a>
            <a
                *ngIf="userService.userHasRight('Visualisation de fiches en masse', tab.droitTitle)"
                class="btn btn-outline-warning"
                #tooltip="matTooltip"
                [matTooltip]="tooltipTranslate.visualisation | translate"
                (click)="visualiser()"
                matTooltipPosition="left"
            >
                <mat-icon>remove_red_eye</mat-icon>
            </a>

            <div style="margin: auto; margin-top: 0; margin-bottom: 0; position: relative">
                <a
                    class="btn btn-outline-warning"
                    #tooltip="matTooltip"
                    [matTooltip]="tooltipTranslate.language | translate"
                    (click)="onOpenLanguages($event)"
                    matTooltipPosition="left"
                >
                    <mat-icon>language</mat-icon>
                </a>
                <div
                    #languagesElementRef
                    class="languages"
                    [ngClass]="{ 'd-none': !isOpenLanguages }"
                >
                    <ng-container *ngIf="switchOn === 'tree'">
                        <mat-select
                            [value]="getSelectedLanguageKey()"
                            (selectionChange)="onChangeLanguageByKey($event.value)"
                            style="width: calc(100% - 10px)"
                        >
                            <mat-option *ngFor="let language of languages" [value]="language.key">{{
                                language.label
                            }}</mat-option>
                        </mat-select>
                    </ng-container>
                    <ng-container *ngIf="switchOn !== 'tree'">
                        <div class="form-check" *ngFor="let language of languages">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                [id]="language.key"
                                [(ngModel)]="language.selected"
                                (change)="onChangeLanguage(language)"
                            />
                            &nbsp;<label class="form-check-label" [attr.for]="language.key">{{
                                language.label
                            }}</label>
                        </div>
                    </ng-container>
                </div>
            </div>

            <a
                *ngIf="hasTreeFlat"
                class="btn btn-outline-warning"
                #tooltip="matTooltip"
                matTooltip="Switcher d'affichage"
                (click)="onSwitchOn()"
                matTooltipPosition="left"
            >
                <mat-icon>repeat</mat-icon>
            </a>

            <a
                *ngIf="userService.userHasRight('Import', tab.droitTitle)"
                class="btn btn-outline-warning"
                #tooltip="matTooltip"
                [matTooltip]="tooltipTranslate.import | translate"
                (click)="importerfichier()"
                matTooltipPosition="left"
            >
                <mat-icon>file_download</mat-icon>
            </a>
            <a
                *ngIf="userService.userHasRight('Export', tab.droitTitle)"
                class="btn btn-outline-warning"
                #tooltip="matTooltip"
                [matTooltip]="tooltipTranslate.export | translate"
                (click)="exporterfichier()"
                matTooltipPosition="left"
            >
                <mat-icon>file_upload</mat-icon>
            </a>
            <ng-container *ngIf="hasFiltres()">
                <a
                    class="btn btn-outline-warning"
                    #tooltip="matTooltip"
                    matTooltip="Vider les filtres"
                    (click)="viderfiltres()"
                    matTooltipPosition="left"
                >
                    <mat-icon>filter_alt_off</mat-icon>
                </a>
            </ng-container>
            <!--
      <a class="btn btn-outline-warning" (click)="onExportIdml()" #tooltip="matTooltip" matTooltip="Catalogue" matTooltipPosition="left">
        <mat-icon>menu_book</mat-icon>
      </a>
      -->
            <a
                *ngIf="userService.userHasRight('Suppression en masse', tab.droitTitle)"
                class="btn btn-danger"
                (click)="suppressiondemasse()"
                #tooltip="matTooltip"
                [matTooltip]="tooltipTranslate.delete | translate"
                matTooltipPosition="left"
            >
                <mat-icon>delete</mat-icon>
            </a>
        </div>
        <div
            [ngClass]="{
                'col-md-11 d-flex flex-column': tab.isMenuVisible,
                'd-flex flex-column': !tab.isMenuVisible
            }"
            style="position: relative; height: inherit; display: flex; flex-direction: column"
        >
            <div class="row visu">
                <div class="col-lg-10 offset-md-1" style="position: relative; float: right">
                    <button mat-button [matMenuTriggerFor]="visualisationMenu" style="float: right">
                        <span
                            >{{ 'Admin.Table.visualisation' | translate }}
                            <strong>{{
                                defaultVisualisation ? ': ' + defaultVisualisation : ''
                            }}</strong>
                        </span>
                    </button>
                    <mat-menu #visualisationMenu="matMenu" classList="admin">
                        <button
                            *ngIf="
                                userService.userHasRight(
                                    'Gestion des visualisations',
                                    tab.droitTitle
                                )
                            "
                            mat-menu-item
                            class="cree btn-outline-warning text-center"
                            (click)="creerVisualisation()"
                        >
                            <span>{{ 'Admin.Table.createVisualisation' | translate }}</span>
                        </button>
                        <button
                            mat-menu-item
                            *ngFor="let view of views"
                            class="container-fluid cree btn-outline-warning btn-action"
                        >
                            <div class="row">
                                <mat-radio-button
                                    class="col-2"
                                    (click)="selectView(view)"
                                    [name]="view.id"
                                    [id]="view.id"
                                    [value]="view.favori"
                                    [checked]="view.isselected"
                                ></mat-radio-button>
                                <span class="col-7" style="padding-left: 10px">{{ view.nom }}</span>
                                <div
                                    *ngIf="
                                        userService.userHasRight(
                                            'Gestion des visualisations',
                                            tab.droitTitle
                                        )
                                    "
                                    class="col-1"
                                >
                                    <a
                                        class="btnedit"
                                        #tooltip="matTooltip"
                                        matTooltip="Modifier"
                                        matTooltipPosition="left"
                                        (click)="editVisualisation(view.id)"
                                    >
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                </div>
                                <div
                                    *ngIf="
                                        userService.userHasRight(
                                            'Gestion des visualisations',
                                            tab.droitTitle
                                        )
                                    "
                                    class="col-1"
                                >
                                    <a
                                        class="btnedit"
                                        #tooltip="matTooltip"
                                        matTooltip="Favori"
                                        matTooltipPosition="left"
                                        (click)="setFavoriView(view)"
                                    >
                                        <mat-icon *ngIf="!isFavoriView(view)"
                                            >star_outline</mat-icon
                                        >
                                        <mat-icon *ngIf="isFavoriView(view)">star</mat-icon>
                                    </a>
                                </div>
                                <div
                                    *ngIf="
                                        userService.userHasRight(
                                            'Gestion des visualisations',
                                            tab.droitTitle
                                        )
                                    "
                                    class="col-1"
                                >
                                    <a
                                        class="btnedit"
                                        #tooltip="matTooltip"
                                        matTooltip="Supprimer"
                                        matTooltipPosition="left"
                                        (click)="supprimView(view)"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </div>
                            </div>
                        </button>
                    </mat-menu>
                </div>
            </div>
            <div class="row">
                <div class="col enr">
                    <div class="px-2">
                        {{ 'Admin.Table.numberOfRecords' | translate }} :
                        <strong>{{ totalElements }} </strong>
                    </div>
                    <div
                        *ngIf="userService.userHasRight('Recherche par mots clés', tab.droitTitle)"
                    >
                        <mat-form-field appearance="outline" style="font-size: 10px; width: 300px">
                            <mat-label>{{ 'Admin.Table.searchKeyword' | translate }}</mat-label>
                            <input
                                matInput
                                (keyup)="filtreMotCles($event)"
                                [(ngModel)]="recherche"
                                placeholder="Ex. Mia"
                                #input
                            />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <mat-paginator
                #paginator
                aria-label="Select page of"
                [length]="totalElements"
                [pageIndex]="paginatorPageIndex"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="nextPage($event)"
            >
            </mat-paginator>
            <div class="line"></div>
            <div></div>

            <div class="example-container">
                <div
                    style="
                        border: 1px solid #0373bc;
                        border-radius: 3px;
                        padding-left: 10px;
                        padding-right: 10px;
                    "
                    *ngIf="switchOn === 'tree'"
                >
                    <mat-tree [dataSource]="treeFlatDataSource" [treeControl]="treeControl">
                        <!-- Template pour les éléments sans enfants -->
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                            <a
                                href="#"
                                (click)="ouvrirOnglet(node.name); (false)"
                                style="text-decoration: none; color: #0373bc"
                                ><span style="color: 'green'">[{{ node.name.depth }}]</span>
                                {{ retrieveTreeName(node.name) }}</a
                            >
                        </mat-tree-node>

                        <!-- Template pour les éléments avec enfants -->
                        <mat-tree-node
                            *matTreeNodeDef="let node; when: hasChild"
                            matTreeNodePadding
                        >
                            <a
                                href="#"
                                (click)="ouvrirOnglet(node.name); (false)"
                                style="text-decoration: none; color: #0373bc"
                                ><span style="color: 'green'">[{{ node.name.depth }}]</span>
                                {{ retrieveTreeName(node.name) }}</a
                            >
                            <mat-icon matTreeNodeToggle>
                                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </mat-tree-node>
                    </mat-tree>
                </div>

                <table
                    *ngIf="switchOn === 'table' && pageOption === pageOptions.WAIT"
                    mat-table
                    [dataSource]="datasource"
                    matSort
                    matSortActive="code"
                    class="mat-elevation-z8"
                    (matSortChange)="onSortChange($event)"
                >
                    <ng-container
                        *ngFor="let column of listedechamps; trackBy: trackByColumn"
                        [matColumnDef]="column"
                    >
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            sortActionDescription="Sort by code"
                            [disabled]="column === 'select'"
                            class="p-1"
                        >
                            <div *ngIf="column === 'select'" class="th-flex">
                                <mat-checkbox
                                    (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()"
                                >
                                </mat-checkbox>
                            </div>
                            <div *ngIf="column === 'select'" class="th-flex">
                                <!-- {{column| uppercase}} -->
                            </div>
                            <div *ngIf="column === 'tels'" class="th-flex">
                                TELEPHONES

                                <a
                                    class="btn filter-btn"
                                    #tooltip="matTooltip"
                                    matTooltip="Filtrer"
                                    (click)="filtrer($event, column)"
                                    matTooltipPosition="left"
                                    [ngClass]="{ active: filtreActive(column) }"
                                    *ngIf="!isDefaultFilter(column)"
                                >
                                    <mat-icon class="filter-icon">filter_alt</mat-icon>
                                </a>
                            </div>
                            <div *ngIf="column != 'select' && column != 'tels'" class="th-flex">
                                {{ retrieveLabel(column) | uppercase }}

                                <a
                                    class="btn filter-btn"
                                    #tooltip="matTooltip"
                                    matTooltip="Filtrer"
                                    (click)="filtrer($event, column)"
                                    matTooltipPosition="left"
                                    [ngClass]="{ active: filtreActive(column) }"
                                    *ngIf="!isDefaultFilter(column) || column == 'statut'"
                                >
                                    <mat-icon class="filter-icon">filter_alt</mat-icon>
                                </a>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element" class="p-1 text-start">
                            <div *ngIf="column === 'select'" class="th-flex">
                                <mat-checkbox
                                    (click)="$event.stopPropagation()"
                                    #selectAfterAdding
                                    (change)="$event ? toggleSelection(element) : null"
                                    [checked]="selection.isSelected(element)"
                                    [aria-label]="checkboxLabel(element)"
                                >
                                </mat-checkbox>
                            </div>

                            <app-dynamic-table-column
                                [columnDefs]="columnDefs"
                                [columnData]="element[column]"
                                [elementdata]="element"
                                [columnName]="column"
                                [languages]="languages"
                                [entite]="tab.entite"
                            ></app-dynamic-table-column>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="listedechamps; sticky: true"></tr>
                    <tr
                        mat-row
                        (click)="clickSelection.add(row)"
                        (click)="ouvrirOnglet(row)"
                        *matRowDef="let row; columns: listedechamps"
                    ></tr>
                </table>
            </div>
        </div>
    </div>
</div>
